function hasValue(value) {
  return value !== undefined && value !== null && String(value).trim() !== "";
}

function getConfig(name, defaultValue = null) {
  const runtimeEnv = typeof window !== "undefined" ? window.ENV : undefined;

  if (runtimeEnv !== undefined) {
    const runtimeValue = runtimeEnv[name] ?? runtimeEnv[`REACT_APP_${name}`];
    if (hasValue(runtimeValue)) {
      return runtimeValue;
    }
  }

  if (typeof process !== "undefined" && process.env) {
    const buildValue = process.env[name] ?? process.env[`REACT_APP_${name}`];
    if (hasValue(buildValue)) {
      return buildValue;
    }
  }

  return defaultValue;
}

export function getBackendUrl() {
  const custom = getConfig("BACKEND_URL") || getConfig("REACT_APP_BACKEND_URL");
  if (hasValue(custom)) {
    return String(custom).replace(/\/+$/, "");
  }

  if (typeof process !== "undefined" && process.env) {
    const fromEnv = process.env.BACKEND_URL || process.env.REACT_APP_BACKEND_URL;
    if (hasValue(fromEnv)) {
      return String(fromEnv).replace(/\/+$/, "");
    }
  }

  if (typeof window !== "undefined" && window.location) {
    const host = window.location.hostname;
    if (host !== "localhost" && host !== "127.0.0.1") {
      if (host.startsWith("frontend.")) {
        return `${window.location.protocol}//${host.replace(/^frontend\./, "backend.")}`;
      }
      return `${window.location.protocol}//${host}:8089`;
    }
    return `${window.location.protocol}//${host}:8089`;
  }

  return "http://localhost:8089";
}

export function getFrontendPort() {
  return getConfig("PORT") || getConfig("PORT");
}

export function getNumberSupport() {
  return getConfig("REACT_APP_NUMBER_SUPPORT") || getConfig("NUMBER_SUPPORT");
}

export function getSystemName() {
  return (
    getConfig("REACT_APP_NAME_SYSTEM") ||
    getConfig("NAME_SYSTEM") ||
    ""
  );
}

export function getEnvToken() {
  const runtimeToken =
    (window.ENV && (window.ENV.REACT_APP_ENV_TOKEN || window.ENV.ENV_TOKEN)) ||
    null;
  return runtimeToken;
}

export function getFacebookAppId() {
  return getConfig("REACT_APP_FACEBOOK_APP_ID") || getConfig("FACEBOOK_APP_ID");
}

export function getRequireBusinessManagement() {
  return (
    getConfig("REACT_APP_REQUIRE_BUSINESS_MANAGEMENT") ||
    getConfig("REQUIRE_BUSINESS_MANAGEMENT")
  );
}

export function getCloudApiAppId() {
  return (
    getConfig("REACT_APP_CLOUD_API_APP_ID") ||
    getConfig("CLOUD_API_APP_ID") ||
    getConfig("REACT_APP_FACEBOOK_APP_ID") ||
    getConfig("FACEBOOK_APP_ID")
  );
}

export function getCloudApiConfigId() {
  return (
    getConfig("REACT_APP_CLOUD_API_CONFIG_ID") ||
    getConfig("CLOUD_API_CONFIG_ID")
  );
}

export function getWebhookVerifyToken() {
  return (
    getConfig("REACT_APP_VERIFY_TOKEN") ||
    getConfig("VERIFY_TOKEN") ||
    "360house1986"
  );
}

export function getTicketsRealtimeFallbackIntervalMs() {
  const rawValue =
    getConfig("REACT_APP_TICKETS_REALTIME_FALLBACK_INTERVAL_MS") ||
    getConfig("TICKETS_REALTIME_FALLBACK_INTERVAL_MS") ||
    "30000";

  const parsed = Number(rawValue);
  if (!Number.isFinite(parsed)) {
    return 30000;
  }

  // O fallback só cobre indisponibilidade do socket e não deve virar polling agressivo.
  return Math.max(30000, Math.min(60000, Math.floor(parsed)));
}
